import { render, staticRenderFns } from "./column_list.vue?vue&type=template&id=f9f7d150&scoped=true&"
import script from "./column_list.vue?vue&type=script&lang=js&"
export * from "./column_list.vue?vue&type=script&lang=js&"
import style0 from "./column_list.vue?vue&type=style&index=0&id=f9f7d150&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f7d150",
  null
  
)

export default component.exports